import React from "react"
import { RichText } from "prismic-reactjs"
import styled from "@emotion/styled"
import dimensions from "styles/dimensions"
import PropTypes from "prop-types"

const VideoCardContainer = styled("div")`
  display: flex;
  flex-direction: row;
  margin-bottom: 120px;

  text-decoration: none;
  color: currentColor;

  @media (max-width: 950px) {
    flex-direction: column;
  }

  @media (max-width: ${dimensions.maxwidthMobile}px) {
    margin: 0 32px 120px 32px;
  }
`

const VideoCardContent = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 50%;
  overflow: hidden;
  background: white;
  padding: 0 4em;
  margin-bottom: 32px;

  h4,
  h5,
  h6 {
    width: 100%;
  }

  h4 {
    margin-bottom: 0;
  }

  p {
    margin-top: 8px;
    width: 100%;
  }

  @media (max-width: 1280px) {
    padding: 0 2em;
  }

  @media (max-width: 950px) {
    width: 100%;
    padding: 0;
  }

  @media (min-width: 455px) and (max-width: 950px) {
    h4,
    h5,
    h6,
    p {
      text-align: center;
    }
  }
`

const VideoContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 50%;
  overflow: hidden;
  position: relative;

  @media (max-width: 950px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  video {
    max-width: 100%;
    max-height: 85vh;
    }
  }
`

const VideoCard = ({ subline, title, description, videourl }) => {
  return (
    <VideoCardContainer className="imageWrapper">
      <VideoCardContent className="VideoCardContent">
        {RichText.render(title)}
        {subline && <h6>{subline[0].text}</h6>}
        {RichText.render(description)}
      </VideoCardContent>
      <VideoContainer className="VideoCardImageContainer">
        <video
          controls
          autoPlay={true}
          width="100%"
          loop
          muted
          disablePictureInPicture
        >
          <source src={videourl} type="video/mp4" />
        </video>
      </VideoContainer>
    </VideoCardContainer>
  )
}

export default VideoCard

VideoCard.propTypes = {
  title: PropTypes.array.isRequired,
}
